import React from 'react';
import TrashCan from 'yoda-core-components/lib/assets/svg/TrashCan.svg';
import Recycle from 'yoda-core-components/lib/assets/svg/Recycle.svg';
import InformationNew from 'yoda-core-components/lib/assets/svg/InformationNew.svg';
import Store from 'yoda-core-components/lib/assets/svg/Store.svg';
import WarningGeneral from 'yoda-core-components/lib/assets/svg/WarningGeneral.svg';
import ShieldNew from 'yoda-core-components/lib/assets/svg/ShieldNew.svg';

const generalInfo = {
    disposalFee: {
        id: 'disposal-fee',
        title: 'Disposal Fee',
        icon: 'trash-can',
        iconComponent: <TrashCan />,
        html: 'Please note that some states may charge a disposal fee per item.',
        link: 'See details',
        imgDimention: '24px',
    },
    recycleFee: {
        id: 'recycle-fee',
        title: 'Recycling Fee',
        icon: 'recycle',
        iconComponent: <Recycle />,
        html: 'Please note that some states may charge a recycling fee per item.',
        link: 'See details',
        imgDimention: '24px',
    },
    needHelp: {
        title: 'Need Help',
        icon: 'information-new',
        iconComponent: <InformationNew />,
        link: '(1-844-527-2775)',
        href: 'tel:+1-844-527-2775',
        imgDimention: '24px',
    },
    inStoreDisplay: {
        title: 'InStore Display',
        icon: 'store',
        iconComponent: <Store />,
        html: 'Check for stores with major appliance display.',
        findStoreLink: 'Find A Store',
        imgDimention: '24px',
    },
    proposition65: {
        id: 'prop65-warning-info',
        title: 'Proposition 65 WARNING',
        icon: 'warning-general',
        iconComponent: <WarningGeneral />,
        html: '',
        link: 'See Details',
        imgDimention: '24px',
    },
    majorAppliance: {
        title: 'Protection Plan Terms & Conditions',
        icon: 'shield-new',
        iconComponent: <ShieldNew />,
        html: 'Limitations and exclusions may apply for major appliances',
        link: 'See details',
        imgDimention: '24px',
        href: 'http://www.jcpenney.com/dotcom//images/MajorAppliance.pdf',
    },
    jeweleryAndWatch: {
        title: 'Protection Plan Terms & Conditions',
        icon: 'shield-new',
        iconComponent: <ShieldNew />,
        html: 'Limitations and exclusions may apply for watches and jewelry.',
        link: 'See details',
        imgDimention: '24px',
        href: 'https://www.jcpenney.com/m/protection-plan-faq?faqTopicId=47200153',
    },
    protectionPlan: {
        title: 'Protection Plan Terms & Conditions',
        icon: 'shield-new',
        iconComponent: <ShieldNew />,
        html: 'Limitations and exclusions may apply.',
        link: 'See details',
        imgDimention: '24px',
        href: 'https://www.jcpenney.com/m/non-jewelry-protection-plan-faq?faqTopicId=47200154',
    },
};

export default generalInfo;
